import React, { useContext } from "react";
import AppContext from "context/Context";
import { Accordion, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";
import createMarkup from "helpers/createMarkup";

const ContactCards = ({ contacts }) => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();

	return (
		<>
			{contacts.map((item) => (
				<Col key={item.id} md={4} className="d-flex">
					<div className={styles.contactContainer}>
						<Row>
							<Col key={item.id} md={2} xs={2} sm={2}>
								<div className={`${styles.contactCenter}`}>
									<img src={item.image} />
								</div>
							</Col>
							<Col key={"test" + item.id} md={10} xs={10} sm={9}>
								<div className={`${styles.contactTitle} ${styles.size16}`}>{t(item.title)}</div>
								<div className={`${styles.size16} ${styles.contactDescription} `} dangerouslySetInnerHTML={createMarkup(t(item.description))} />
							</Col>
						</Row>
					</div>
				</Col>
			))}
		</>
	);
};

export default ContactCards;
